import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import classNames from 'classnames'
import striptags from 'striptags'

import CouponCodeInput from 'components/CouponCodeInput'

export const PrivacyPolicyCheck = injectIntl(({ intl, company }) => {
  const { formatMessage } = intl

  return (
    <div
      className="input input--checkbox"
    >
      <input
        type="checkbox"
        value="false"
        required
      />
      <label className="input__label">
        <FormattedMessage id="app.event.reservation.i-accept-the-following" />
        <a href={formatMessage({ id: 'app.root.privacy-policy-url' })}
          className="reservation-form__link iubenda-nostyle no-brand iubenda-embed"
          title="Privacy Policy"
          target="_blank" rel="noreferrer"
        >
          Privacy Policy
        </a>,
        <a href={formatMessage({ id: 'app.root.terms-and-conditions-url' })}
          className="reservation-form__link iubenda-nostyle no-brand iubenda-embed"
          title="Privacy Policy"
          target="_blank" rel="noreferrer"
        >
          <FormattedMessage id="app.root.terms-and-conditions" />
        </a>.&nbsp;
        <FormattedMessage
          id="app.event.reservation.and-the-following"
          values={{ company }}
        />
      </label>
    </div>
  )
})

export const TextField = ({
  field,
  translationId,
  fieldLabel,
  type = 'text',
  data,
  onChange,
  errors = {},
  required = true,
}) => {
  const error = errors[field]

  const label = fieldLabel !== undefined
    ? (
      <label
        className="form__label form__label--inline-children"
        dangerouslySetInnerHTML={{
          __html: `${required ? '<span>*&nbsp</span>' : ''}${fieldLabel}`,
        }}
      ></label>
    )
    : (
      <label className="form__label">
        {required ? '* ' : ''}<FormattedMessage id={translationId} />
      </label>
    )

  return (
    <div
      className={
        classNames('form__field', {
          'form__field--invalid': error,
        })}
    >
      { label }
      <input
        type={type}
        className="form__input"
        value={data.data[field]}
        onChange={(e) => onChange({ data: { [field]: e.target.value } })}
        required={required}
      />
      {error && <div className="form__error">{error}</div>}
    </div>
  )
}
TextField.propTypes = {
  field: PropTypes.string,
  translationId: PropTypes.string,
  fieldLabel: PropTypes.string,
  type: PropTypes.string,
  data: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  required: PropTypes.bool,
}

export const ChoiceField = ({
  field,
  fieldLabel,
  type = 'checkbox',
  options,
  data,
  onChange,
  errors = {},
  required = true,
}) => {
  const error = errors[field]

  const elements = []
  const choiceOnChange = ({ target }) => {
    const { value, checked } = target
    const d = data.data[field]
    let datum = Array.isArray(d)
      ? d.slice()
      : d || []

    if (checked && type === 'radio') {
      datum = value
    } else if (checked && type === 'checkbox') {
      datum.push(value)
    } else if (!checked && type === 'radio') {
      // datum = '';
    } else if (!checked && type === 'checkbox') {
      const index = datum.indexOf(value)
      datum.splice(index, 1)
    }

    onChange({ data: { [field]: datum } })
  }
  for (const index in options) { // eslint-disable-line guard-for-in
    const { label, title } = options[index]
    const checked = data.data[field] &&
      data.data[field].includes(title)

    elements.push(
      <div key={index}>
        <div className={`input input--${type}`} >
          <input
            name={field}
            type={type}
            value={title}
            checked={checked}
            required={type !== 'checkbox' && required}
            onChange={choiceOnChange}
          />
          <label
            className="input__label"
            dangerouslySetInnerHTML={{
              __html: label,
            }}
          ></label>
        </div>
      </div>
    )
  }

  return (
    <div
      className={
        classNames('form__field', {
          'form__field--invalid': error,
        })}
    >
      <label
        className="form__label form__label--inline-children"
        dangerouslySetInnerHTML={{
          __html: `${required ? '<span>*&nbsp</span>' : ''}${fieldLabel}`,
        }}
      ></label>
      {error && <div className="form__error">{error}</div>}
      {elements}
    </div>
  )
}
ChoiceField.propTypes = {
  field: PropTypes.string,
  translationId: PropTypes.string,
  fieldLabel: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.array,
  data: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  required: PropTypes.bool,
}

export const SelectField = ({
  field,
  translationId,
  fieldLabel,
  options,
  data,
  onChange,
  errors = {},
  required = true,
}) => {
  const error = errors[field]
  const label = fieldLabel !== undefined
    ? (
      <label
        className="form__label form__label--inline-children"
        dangerouslySetInnerHTML={{
          __html: `${required ? '<span>*&nbsp</span>' : ''}${fieldLabel}`,
        }}
      ></label>
    )
    : (
      <label className="form__label">
        <FormattedMessage id={translationId} />{required ? ' *' : ''}
      </label>
    )

  if (!data.data[field]) {
    onChange({ data: { [field]: options[0].title } })
  }

  return (
    <div
      className={
        classNames('form__field', {
          'form__field--invalid': error,
        })}
    >
      { label }
      <select
        className="form__input"
        value={data.data[field]}
        onChange={(e) => onChange({ data: { [field]: e.target.value } })}
        required={required}
      >
        {options.map((option, i) => {
          return (
            <option value={option.title} key={i}>
              {striptags(option.label)}
            </option>
          )
        })}
      </select>
      {error && <div className="form__error">{error}</div>}
    </div>
  )
}
SelectField.propTypes = {
  field: PropTypes.string,
  translationId: PropTypes.string,
  fieldLabel: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.array,
  data: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  required: PropTypes.bool,
}

export const CouponCodeField = ({ errors = {} }) => {
  const error = errors.coupon_code

  return (
    <div
      className={
        classNames('form__field form__field--coupon-code', {
          'form__field--invalid': error,
        })}
    >
      <label className="form__label">
        <FormattedMessage id="app.cart.step.infos.fields.coupon_code" />
      </label>
      <CouponCodeInput />
      { error &&
        <div className="form__error">
          <FormattedMessage id="app.cart.step.infos.fields.coupon_code.invalid" />
        </div>
      }
      <p className="space--both-1 smallprint">
        <FormattedMessage id="app.cart.step.infos.fields.coupon_code.info" />
      </p>
    </div>
  )
}
CouponCodeField.propTypes = {
  errors: PropTypes.object,
}
